// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"260":"bf8651f3","745":"3b806aad"}[chunkId] + ".chunk.js";
};